import React from 'react';
import './CollapsibleSection.css';

interface CollapsibleSectionProps {
  title: string;
  icon?: string; // Kept for API compatibility, not rendered
  children: React.ReactNode;
  sidebarCollapsed: boolean;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  sidebarCollapsed,
}) => {
  return (
    <div className="collapsible-section">
      <div className="section-header" aria-hidden={sidebarCollapsed}>
        <span className="section-header-label">{title}</span>
      </div>
      <div className="collapsible-section-content">{children}</div>
    </div>
  );
};
